export const getPdfArrayBuffer = async (pdfDocumentDefinition) => {
  // Async import for code-splitting.
  const { default: pdfMake } = await import('./pdfmake')
  try {
    const pdf = pdfMake.createPdf(pdfDocumentDefinition)
    const buffer = await pdf.getBuffer()
    return buffer
  } catch (error) {
    // Graceful error handling for the async flow
    console.error('Error generating PDF buffer:', error)
    throw error
  }
}
